import React from 'react';
import styles from '../knowledge-hub.module.scss';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { useKnowledgeHub } from '../hooks/use-knowledge-hub.hooks';
import { ScreenTitle } from 'src/components/design-system';
import { ROUTES } from 'shared/constants';
import { Breadcrumb } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { useBreadcrumbs } from '../hooks/use-breadcrumbs.hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faHome } from '@fortawesome/pro-solid-svg-icons';
import { Tooltip } from 'src/components/core';
import { HubSearch } from './hub-search';

export function RenderHeader({ title, subtitle, upperTitle }) {
  const lang = useSelector(getLang('KNOWLEDGE_HUB'));
  const { sectionTitle, organizationId } = useKnowledgeHub();
  const { breadcrumbItems } = useBreadcrumbs();
  const location = useLocation();
  const isSearchPage = location.pathname.includes(ROUTES.KNOWLEDGE_HUB_SEARCH);

  const rootItem = [
    {
      title: (
        <Tooltip title={lang.GO_TO_KNOWLEDGE_NETWORK_HOME}>
          <FontAwesomeIcon icon={faHome} aria-label={lang.GO_TO_KNOWLEDGE_NETWORK_HOME} />
        </Tooltip>
      ),
      path: ROUTES.KNOWLEDGE_HUB,
    },
  ];
  const showRoot = !!organizationId;

  return (
    <div className={styles.header}>
      <div className={styles.headerTitle}>
        {showRoot && (
          <Breadcrumb
            separator={<FontAwesomeIcon icon={faChevronRight} className={styles.separator} />}
            className={styles.breadcrumbs}
            items={[...rootItem, ...breadcrumbItems]
              .filter(item => item?.path)
              .map((item, index) => ({
                key: index,
                title: <Link to={item.path}>{item.title}</Link>,
              }))}
          />
        )}

        <Link className={styles.upperTitle} to={ROUTES.KNOWLEDGE_HUB}>
          {upperTitle}
        </Link>

        <ScreenTitle title={title || sectionTitle || lang.TITLE} subtitle={subtitle} />

        {!organizationId && !isSearchPage && (
          <p className={styles.welcomeMessage}>{lang.WELCOME_MESSAGE}</p>
        )}
      </div>

      <HubSearch variant="header" />
    </div>
  );
}
